module.exports = __webpack_public_path__ + "static/img/Bailey-Simonsson.ba4b26e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bailey-Simonsson.jpg
// module id = nbif
// module chunks = 0